import {
  COUNT_UNREAD_MESSAGES,
  GO_TO_MESSAGE,
  MAKE_AS_UNREAD_MESSAGE,
  READ_MESSAGE,
} from '../actionTypes/NotificationType';

const INIT_STATE = {
  visit: false,
  count: 0,
};

const notificationReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GO_TO_MESSAGE: {
      return { ...state, visit: action.payload };
    }
    case READ_MESSAGE: {
      return { ...state, count: action.payload };
    }
    case COUNT_UNREAD_MESSAGES: {
      return { ...state, count: action.payload };
    }
    case MAKE_AS_UNREAD_MESSAGE: {
      return { ...state, count: action.payload };
    }
    default:
      return state;
  }
};

export default notificationReducer;
